/**
 * Anonymous counts for the personalisation tools (the studio stats page reads them back).
 *
 * Each count is { maker, kind, value } sent to the AI server's /event, which keeps only a daily
 * total for each: no address, no cookie, no id, nothing about the person. A browser asking not to
 * be tracked (Global Privacy Control) sends nothing.
 *
 * - "view": sent once when a tool's page opens (window.BTF_MAKER, set by snippets/btf-head).
 * - "basket": any add to the basket from that page (/cart/add by fetch, or a plain form).
 * - Choices: a tool calls window.btfTrack(owner, maker, { design, colour, size, ... }) whenever it
 *   redraws. The first call is the page's own starting point and is not counted; after that each
 *   value the customer moves to is counted once per visit.
 */
(() => {
  const API = 'https://btf-ai.beyondthefridge.workers.dev/event';
  const KINDS = ['design', 'colour', 'size', 'format', 'style', 'pet', 'background', 'photo', 'basket', 'view'];
  const off = navigator.globalPrivacyControl === true;
  const sent = new Set();

  const send = (m, k, v = '', again = false) => {
    if (off || !m || !KINDS.includes(k)) return;
    const value = String(v == null ? '' : v).slice(0, 60);
    const key = m + '|' + k + '|' + value;
    if (!again && sent.has(key)) return;
    sent.add(key);
    const body = JSON.stringify({ m, k, v: value });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(API, new Blob([body], { type: 'text/plain' }))) return;
      fetch(API, { method: 'POST', body, keepalive: true, mode: 'no-cors' });
    } catch (e) {
      /* counting never gets in the way */
    }
  };
  window.btfCount = send;

  const last = new WeakMap();
  window.btfTrack = (owner, maker, snap) => {
    if (!owner || !maker || !snap) return;
    const prev = last.get(owner);
    last.set(owner, Object.assign({}, snap));
    if (!prev) return;
    // A new design brings its own colour, shape and words with it: only the design is the
    // customer's choice that time
    if (snap.design != null && snap.design !== prev.design) return send(maker, 'design', snap.design);
    Object.keys(snap).forEach((k) => {
      if (snap[k] != null && snap[k] !== '' && snap[k] !== prev[k]) send(maker, k, snap[k]);
    });
  };

  const maker = () => window.BTF_MAKER || '';
  if (maker()) send(maker(), 'view');

  // Added to the basket from a tool's page, however the tool posts it
  const isAdd = (url) => /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
  const f = window.fetch;
  if (f) {
    window.fetch = function (input, init) {
      try {
        const url = typeof input === 'string' ? input : input && input.url;
        const method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (maker() && method === 'POST' && isAdd(url)) send(maker(), 'basket', '', true);
      } catch (e) {
        /* ignore */
      }
      return f.apply(this, arguments);
    };
  }
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!maker() || !form || !isAdd(form.getAttribute('action'))) return;
    // Only a real page post: tools that post by fetch stop the form, and are counted above
    setTimeout(() => !e.defaultPrevented && send(maker(), 'basket', '', true), 0);
  });
})();
